// extracted by mini-css-extract-plugin
export var addToCartButton = "_sj-b";
export var arrowButtonContainer = "_sj-9";
export var arrowButtonIcon = "_sj-a";
export var carouselArrowButton = "_sj-6";
export var carouselElementContainer = "_sj-1";
export var galleryThumbnail = "_sj-d";
export var galleryThumbnailImage = "_sj-e";
export var left = "_sj-7";
export var productDisplayCarouselContainer = "_sj-0";
export var productTileContainer = "_sj-2";
export var productTileImage = "_sj-4";
export var productTileImageContainer = "_sj-3";
export var productTileTitle = "_sj-5";
export var right = "_sj-8";
export var sliderOverflow = "_sj-c";